/** @format */

import {
    isSubstrateBackordered,
    PROOF_STATUS_PENDING,
    METHOD_NET30,
    PROOF_TYPE_PRINTED,
    PROOF_INTERNAL_COMPLETE,
    PROOF_APPROVAL_CUTOFF,
    ORDER_EXPEDITED_PROCESSING
} from 'frontier-constants';
import withPaymentsHandler from '../../../../invoices/with_payments_handler';
import {PayCharge} from '../../../../invoices/charge/pay_charge';
import {If} from 'frontier-utilities';
import {Link} from 'react-router-dom';
import React, {useState} from 'react';
import Moment from 'moment/moment';

// styles
import './order_status_column.scss';
import {DateFromNow, getLocalTime, IfBeforeCutoff} from 'frontier/utilities/format/date';
import Modal, {ModalBody, ModalHeader} from 'frontier-admin/modal/container_portal';
import DesignUploader from 'frontier/account/components/design_uploader/container';
import SuperAgent from 'superagent';

export const OrderStatusColumn = props => {
    const [isMissingDesignsModelOpen, setIsMissingDesignsModalOpen] = useState(false);
    const {order, cart} = props;

    const pendingCharges = cart.charge_batches.filter(
        ({total, is_complete}) => is_complete === false && total > 0
    );

    const materialExpectedInStockDate = databaseConstants?.backorderedSubstrates.find(
        ({id: backorderedId}) => backorderedId === parseInt(order.substrate_id)
    )?.expected_instock_date;

    let isPendingProof = order.latest_proof?.status === PROOF_STATUS_PENDING;
    if (
        order.latest_proof &&
        parseInt(order.latest_proof.type_id) === PROOF_TYPE_PRINTED &&
        parseInt(order.latest_proof.internal_status) !== PROOF_INTERNAL_COMPLETE
    )
        isPendingProof = false;

    const isPendingInvoice =
        !cart.is_paid && parseInt(cart.billing_method_id) === METHOD_NET30 && cart.is_shipped;

    return (
        <div
            className="single-active-order-10cn__column--status"
            title={order.external_status_label}>
            <div>
                <i className={'fa mr-2 ' + order.status_icon} />
                <span>{order.external_status_label}</span>
            </div>

            {/* pending proof */}
            <If condition={isPendingProof}>
                <div>
                    <Link
                        className="single-order-column-31cs__pending-item"
                        to={`/account/proofs/view/${order.id}`}>
                        <i className="fa fa-warning" />
                        <b>
                            <u>Pending Proof</u>
                            <If
                                condition={
                                    order.processing_id === ORDER_EXPEDITED_PROCESSING &&
                                    order.delay_processing === 1
                                }>
                                <IfBeforeCutoff cutoffTime={PROOF_APPROVAL_CUTOFF}>
                                    <>
                                        <br />(
                                        <DateFromNow withoutSuffix>
                                            {getLocalTime(PROOF_APPROVAL_CUTOFF)}
                                        </DateFromNow>{' '}
                                        remaining)
                                    </>
                                </IfBeforeCutoff>
                            </If>
                        </b>
                    </Link>
                    <If
                        condition={
                            order.processing_id === ORDER_EXPEDITED_PROCESSING &&
                            order.delay_processing === 1
                        }>
                        <IfBeforeCutoff cutoffTime={PROOF_APPROVAL_CUTOFF}>
                            <div className="mt-2 " style={{color: '#E5B200'}}>
                                Approve by {PROOF_APPROVAL_CUTOFF}pm ET for
                                <br />
                                expedite processing.
                            </div>
                        </IfBeforeCutoff>
                    </If>
                </div>
            </If>

            <If condition={isPendingInvoice}>
                <Link
                    className="single-order-column-31cs__pending-item d-block"
                    to="/account/charges/index">
                    <i className="fa fa-warning" />
                    <b>
                        <u>Invoice Pending</u>
                    </b>
                </Link>
            </If>
            <If
                condition={
                    order.design_qty != order.design_count ||
                    order.designs_orders.reduce((a, b) => a + b.qty, 0) != order.total_qty
                }>
                <div className="d-flex align-items-center justify-content-start">
                    <i className="fa fa-warning color-alert-negative me-2" />
                    <b
                        role="button"
                        className="color-alert-negative"
                        onClick={() => setIsMissingDesignsModalOpen(true)}>
                        <u>Missing Designs</u>
                    </b>

                    <If condition={isMissingDesignsModelOpen}>
                        <Modal
                            onClose={() => {
                                setIsMissingDesignsModalOpen(false);
                            }}
                            maxWidth={800}>
                            <ModalHeader>
                                <h3>Upload Missing Designs (Order #{order.label})</h3>
                            </ModalHeader>
                            <ModalBody>
                                <DesignUploader
                                    saveFileEndpoint={'/account/designs/add/' + order.id}
                                    designs_orders={order.designs_orders}
                                    designQty={order.design_qty}
                                    totalQty={order.total_qty}
                                    orderId={order.id}
                                />
                            </ModalBody>
                        </Modal>
                    </If>
                </div>
            </If>

            <If condition={isSubstrateBackordered(order.substrate_id)}>
                <div className="d-flex align-items-start justify-content-start">
                    <i className="fa fa-circle-info color-alert-negative me-2" />
                    <b className="color-alert-negative">
                        Material Backordered Until
                        {Moment(materialExpectedInStockDate || '')
                            .utc()
                            .format('MM/DD')}
                    </b>
                </div>
            </If>

            <If condition={pendingCharges.length > 0}>
                {pendingCharges.map(cb => {
                    return (
                        <div key={'charge' + cb.id}>
                            <PayForCharge chargeBatch={cb} />
                        </div>
                    );
                })}
            </If>
        </div>
    );
};

const PayForCharge = withPaymentsHandler(props => {
    const {chargeBatch} = props;

    const [showChargesModal, setShowChargesModal] = useState(false);
    return (
        <>
            <button
                className="single-order-column-31cs__pending-item"
                onClick={() => setShowChargesModal(true)}>
                <i className="fa fa-warning" />
                <b>
                    <u>Charges Pending</u>
                </b>
            </button>
            <PayCharge
                handleToggleModal={() => setShowChargesModal(false)}
                showChargesModal={showChargesModal}
                singleCharge={chargeBatch}
                isPayingSingle
                {...props}
            />
        </>
    );
});
